import { render } from "./BrinkOne.vue?vue&type=template&id=06e13412"
import script from "./BrinkOne.vue?vue&type=script&lang=js"
export * from "./BrinkOne.vue?vue&type=script&lang=js"

import "./BrinkOne.vue?vue&type=style&index=0&id=06e13412&lang=css"
script.render = render

export default script